import React, { useEffect, useRef } from 'react';

interface ISubmitState {
  submitCount: number;
  isSubmitting: boolean;
  hasErrors: boolean;
}

const INVALID_FIELD_SELECTOR = '.MuiInputBase-root.Mui-error';
const FOCUSABLE_SELECTOR = '[role="combobox"], input:not([type="hidden"]):not([aria-hidden="true"]), textarea';

export const useFocusFirstInvalidField = (
  containerRef: React.RefObject<HTMLElement>,
  { submitCount, isSubmitting, hasErrors }: ISubmitState,
) => {
  const handledSubmitCountRef = useRef(submitCount);

  useEffect(() => {
    if (isSubmitting || submitCount === handledSubmitCountRef.current) {
      return;
    }

    handledSubmitCountRef.current = submitCount;

    if (!hasErrors) {
      return;
    }

    const invalidField = containerRef.current?.querySelector(INVALID_FIELD_SELECTOR);
    const target = invalidField?.querySelector<HTMLElement>(FOCUSABLE_SELECTOR);

    target?.focus();
  }, [containerRef, submitCount, isSubmitting, hasErrors]);
};

export default useFocusFirstInvalidField;
